// Category — taxonomy node attached to articles. Mirrors the Drizzle
// row in `packages/db/src/schema/content/categories.ts` so the wire
// shape can be derived from a row + a simple ISO-string projection.
import { z } from 'zod';
const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
export const Category = z.object({
    id: z.string().uuid(),
    slug: z
        .string()
        .regex(/^[a-z0-9](-?[a-z0-9])*$/)
        .min(1)
        .max(96),
    name: z.string().min(1).max(200),
    description: z.string(),
    /** Theme color hint. Must stay hex-only because the web app applies
     *  it directly to badge/swatch style properties. */
    color: z.string().regex(HEX_COLOR_PATTERN),
    /** Optional icon name — resolved against the category-icon registry
     *  on the client; opaque on the wire. */
    icon: z.string(),
    /** Parent category id when this is a subcategory. `null` at root. */
    parentId: z.string().uuid().nullable(),
    /** Manual ordering — lower-numbered categories render first within
     *  a parent group. */
    position: z.number().int().nonnegative(),
    archivedAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=category.js.map